let ocspEventTypes = [
  // ocspResponder
  'OcspResponder list requested',
  'OcspResponder created',
  'OcspResponder requested',
  'OcspResponder updated',
  'OcspResponder deleted'
]

export default ocspEventTypes
